/* tslint:disable */
/* eslint-disable */
/**
 * dynamic-pricing-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { UtilizationPrice } from '../models';
/**
 * UtilizationPriceApi - axios parameter creator
 * @export
 */
export const UtilizationPriceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} [utilizationPriceId] 
         * @param {number} [priceWindowId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilizationPriceDelete: async (utilizationPriceId?: number, priceWindowId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/UtilizationPrice`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (utilizationPriceId !== undefined) {
                localVarQueryParameter['utilizationPriceId'] = utilizationPriceId;
            }

            if (priceWindowId !== undefined) {
                localVarQueryParameter['priceWindowId'] = priceWindowId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [priceWindowId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilizationPriceGet: async (priceWindowId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/UtilizationPrice`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (priceWindowId !== undefined) {
                localVarQueryParameter['priceWindowId'] = priceWindowId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UtilizationPrice} [utilizationPrice] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilizationPricePost: async (utilizationPrice?: UtilizationPrice, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/UtilizationPrice`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(utilizationPrice, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [utilizationPriceId] 
         * @param {UtilizationPrice} [utilizationPrice] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilizationPricePut: async (utilizationPriceId?: number, utilizationPrice?: UtilizationPrice, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/UtilizationPrice`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (utilizationPriceId !== undefined) {
                localVarQueryParameter['utilizationPriceId'] = utilizationPriceId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(utilizationPrice, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UtilizationPriceApi - functional programming interface
 * @export
 */
export const UtilizationPriceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UtilizationPriceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} [utilizationPriceId] 
         * @param {number} [priceWindowId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async utilizationPriceDelete(utilizationPriceId?: number, priceWindowId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UtilizationPrice>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.utilizationPriceDelete(utilizationPriceId, priceWindowId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UtilizationPriceApi.utilizationPriceDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [priceWindowId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async utilizationPriceGet(priceWindowId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UtilizationPrice>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.utilizationPriceGet(priceWindowId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UtilizationPriceApi.utilizationPriceGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UtilizationPrice} [utilizationPrice] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async utilizationPricePost(utilizationPrice?: UtilizationPrice, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UtilizationPrice>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.utilizationPricePost(utilizationPrice, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UtilizationPriceApi.utilizationPricePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [utilizationPriceId] 
         * @param {UtilizationPrice} [utilizationPrice] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async utilizationPricePut(utilizationPriceId?: number, utilizationPrice?: UtilizationPrice, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UtilizationPrice>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.utilizationPricePut(utilizationPriceId, utilizationPrice, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UtilizationPriceApi.utilizationPricePut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UtilizationPriceApi - factory interface
 * @export
 */
export const UtilizationPriceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UtilizationPriceApiFp(configuration)
    return {
        /**
         * 
         * @param {number} [utilizationPriceId] 
         * @param {number} [priceWindowId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilizationPriceDelete(utilizationPriceId?: number, priceWindowId?: number, options?: any): AxiosPromise<UtilizationPrice> {
            return localVarFp.utilizationPriceDelete(utilizationPriceId, priceWindowId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [priceWindowId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilizationPriceGet(priceWindowId?: number, options?: any): AxiosPromise<Array<UtilizationPrice>> {
            return localVarFp.utilizationPriceGet(priceWindowId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UtilizationPrice} [utilizationPrice] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilizationPricePost(utilizationPrice?: UtilizationPrice, options?: any): AxiosPromise<UtilizationPrice> {
            return localVarFp.utilizationPricePost(utilizationPrice, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [utilizationPriceId] 
         * @param {UtilizationPrice} [utilizationPrice] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilizationPricePut(utilizationPriceId?: number, utilizationPrice?: UtilizationPrice, options?: any): AxiosPromise<UtilizationPrice> {
            return localVarFp.utilizationPricePut(utilizationPriceId, utilizationPrice, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UtilizationPriceApi - object-oriented interface
 * @export
 * @class UtilizationPriceApi
 * @extends {BaseAPI}
 */
export class UtilizationPriceApi extends BaseAPI {
    /**
     * 
     * @param {number} [utilizationPriceId] 
     * @param {number} [priceWindowId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilizationPriceApi
     */
    public utilizationPriceDelete(utilizationPriceId?: number, priceWindowId?: number, options?: RawAxiosRequestConfig) {
        return UtilizationPriceApiFp(this.configuration).utilizationPriceDelete(utilizationPriceId, priceWindowId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [priceWindowId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilizationPriceApi
     */
    public utilizationPriceGet(priceWindowId?: number, options?: RawAxiosRequestConfig) {
        return UtilizationPriceApiFp(this.configuration).utilizationPriceGet(priceWindowId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UtilizationPrice} [utilizationPrice] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilizationPriceApi
     */
    public utilizationPricePost(utilizationPrice?: UtilizationPrice, options?: RawAxiosRequestConfig) {
        return UtilizationPriceApiFp(this.configuration).utilizationPricePost(utilizationPrice, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [utilizationPriceId] 
     * @param {UtilizationPrice} [utilizationPrice] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilizationPriceApi
     */
    public utilizationPricePut(utilizationPriceId?: number, utilizationPrice?: UtilizationPrice, options?: RawAxiosRequestConfig) {
        return UtilizationPriceApiFp(this.configuration).utilizationPricePut(utilizationPriceId, utilizationPrice, options).then((request) => request(this.axios, this.basePath));
    }
}

